import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { actions as assetActions } from '../../actions/asset';
import { actions as clipperMovieActions } from '../../actions/clipperMovie';
import LuciPropTypes from '../../propTypes';
import TimelineGraphic from './TimelineGraphic';
import ConfirmEndEditDialog from './ConfirmEndEditDialog';

const Container = styled.div`
  margin: 1rem 4rem;
`;

const Duration = styled.div`
  font-family: Verdana;
  font-size: 10pt;
  text-align: right;
  margin-right: -2.5rem;
`;

const TimelineBox = styled.div`
  border: 1px solid rgb(158, 157, 157);
  height: 48px;
  position: relative;
  width: 100%;
`;

const TimelineScrubber = styled.div`
  position: relative;
  top: -56px;
  height: 95px;
  width: 20px;
`;

const TimelineBar = styled.div`
  background-color: rgb(70, 144, 254);
  position: relative;
  left: -1px;
  height: 100%;
  width: 2px;
  z-index: 50;
`;

const TimelineScrubberArrow = styled.svg`
  left: -5.75px;
  top: -5px;
  position: relative;
  height: 8px;
  width: 12px;
  z-index: 51;
`;

class Timeline extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmEndEditDialogVisible: false,
      enabled: true,
      selectedId: ''
    };

    this.handleOnDragOver = this.handleOnDragOver.bind(this);
    this.handleOnDragLeave = this.handleOnDragLeave.bind(this);
    this.handleOnDrop = this.handleOnDrop.bind(this);
    this.handleOnMouseDown = this.handleOnMouseDown.bind(this);
    this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
    this.handleOnGraphicClick = this.handleOnGraphicClick.bind(this);
    this.handleOnConfirmCloseEdit = this.handleOnConfirmCloseEdit.bind(this);
    this.resetState = this.resetState.bind(this);
  }
  UNSAFE_componentWillMount() {
    document.addEventListener('mousedown', this.handleOnMouseDown);
    document.addEventListener('keydown', this.handleOnKeyDown);
  }
  componentDidUpdate() {
    const timelineBox = this.timeline.getBoundingClientRect();
    this.timelineBoxLeft = timelineBox.left;
    this.timelineBoxWidth = timelineBox.width;
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOnMouseDown);
    document.removeEventListener('keydown', this.handleOnKeyDown);
  }
  resetState() {
    this.setState({ confirmEndEditDialogVisible: false });
  }
  handleOnDragOver(event) {
    event.preventDefault();
    const isSourcePreview = event.nativeEvent.dataTransfer.types.includes('preview');
    if (isSourcePreview) {
      if (this.props.currentAsset.mosObjectId) {
        this.setState({ enabled: false });
      } else {
        const xPos = event.nativeEvent.clientX - this.timelineBoxLeft;
        const newPosition = Math.round((xPos * 1000) / this.timelineBoxWidth);
        if (newPosition !== this.props.position) {
          this.props.onPreviewDragOver(newPosition, this.props.isPlaying);
        }
      }
    }
  }
  handleOnDrop(event) {
    this.handleOnDragLeave();
    const data = event.dataTransfer.getData('text');
    if (data === ' ') {
      event.preventDefault();
      if (!this.props.currentAsset.mosObjectId) {
        this.props.onPreviewDrop();
      } else {
        this.props.onPreviewDropExisting();
      }
    }

    this.props.exitTemplateEdit();
    this.resetState();
  }
  handleOnMouseDown() {
    this.props.onLoseFocus();
  }
  handleOnDragLeave() {
    this.setState({ enabled: true });
  }
  handleOnKeyDown(event) {
    const keyCode = event.keyCode || event.which;

    if (keyCode === 46 || keyCode === 8) {
      const focusedGraphic = this.props.timelineGraphics.find(g => g.focused);
      if (focusedGraphic) {
        this.props.onDeletePress(focusedGraphic.mosObjectId);
      }
    }
  }
  handleOnGraphicClick(selectedId) {
    const selectedGraphic = this.props.timelineGraphics.find(g => g.id === selectedId);
    if (selectedGraphic &&
      this.props.currentAsset.mosObjectId &&
      this.props.currentAsset.mosObjectId !== selectedGraphic.mosObjectId) {
      this.setState({ confirmEndEditDialogVisible: true, selectedId });
    } else {
      this.props.onSelectGraphic(selectedId);
    }
  }
  handleOnConfirmCloseEdit() {
    this.props.onSelectGraphic(this.state.selectedId);
    this.props.exitTemplateEdit();
    this.resetState();
  }
  renderTimelineScrubber() {
    if (this.props.isScrubbing && !this.props.timelineGraphics.some(g => g.selected)) {
      const percent = this.props.position / 10;
      const left = `${percent}%`;
      return (
        <TimelineScrubber style={{ left }}>
          <TimelineBar />
          <TimelineScrubberArrow>
            <polygon points="0,8 6,0 12,8" style={{ fill: 'white', stroke: 'rgb(99,98,98)', strokeWidth: 1 }} />
          </TimelineScrubberArrow>
        </TimelineScrubber>
      );
    }
  }
  render() {
    return (
      <Container>
        <Duration>
          {this.props.duration}
        </Duration>
        <TimelineBox
          style={{ background: this.state.enabled ? 'white' : 'rgb(210, 207, 204)' }}
          ref={div => { this.timeline = div; }}
          onDragOver={this.handleOnDragOver}
          onDragLeave={this.handleOnDragLeave}
          onDrop={this.handleOnDrop}
        >
          {this.renderTimelineScrubber()}
          {this.props.timelineGraphics.map(graphic => (
            <TimelineGraphic
              key={graphic.id}
              enabled={this.state.enabled}
              graphic={graphic}
              onClick={(id) => this.handleOnGraphicClick(id)}
            />
          ))}
        </TimelineBox>
        <ConfirmEndEditDialog
          isOpen={this.state.confirmEndEditDialogVisible}
          onCancelClick={this.resetState}
          onOkClick={this.handleOnConfirmCloseEdit}
        />
      </Container>
    );
  }
}

Timeline.defaultProps = {
  currentAsset: null
};

Timeline.propTypes = {
  currentAsset: LuciPropTypes.Asset,
  duration: PropTypes.string.isRequired,
  isPlaying: PropTypes.bool.isRequired,
  isScrubbing: PropTypes.bool.isRequired,
  position: PropTypes.number.isRequired,
  timelineGraphics: PropTypes.arrayOf(PropTypes.shape({
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired,
    focused: PropTypes.bool.isRequired,
    selected: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired).isRequired,
  onLoseFocus: PropTypes.func.isRequired,
  onDeletePress: PropTypes.func.isRequired,
  onPreviewDragOver: PropTypes.func.isRequired,
  onPreviewDrop: PropTypes.func.isRequired,
  onPreviewDropExisting: PropTypes.func.isRequired,
  onSelectGraphic: PropTypes.func.isRequired,
  exitTemplateEdit: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  currentAsset: state.asset.asset,
  duration: state.clipperMovie.duration,
  isPlaying: state.clipperMovie.isPlaying,
  isScrubbing: state.clipperMovie.isScrubbing,
  position: state.clipperMovie.currentPosition,
  timelineGraphics: state.clipperMovie.timelineGraphics
});

const mapDispatchToProps = {
  onLoseFocus: clipperMovieActions.loseGraphicFocus,
  onDeletePress: clipperMovieActions.removeSelectedGraphic,
  onPreviewDragOver: clipperMovieActions.scrubVideo,
  onPreviewDrop: assetActions.createNewMosObject,
  onPreviewDropExisting: assetActions.updateMosObject,
  onSelectGraphic: clipperMovieActions.selectGraphic,
  exitTemplateEdit: assetActions.endEditAsset
};

export default connect(mapStateToProps, mapDispatchToProps)(Timeline);



// WEBPACK FOOTER //
// ./app/components/Clipper/Timeline.js